import React, { forwardRef, Ref } from 'react';
import classNames from 'classnames';
import { FieldTextAreaProps } from './types';
import fieldStyles from '../Field/styles.sass';
import styles from './styles.sass';

/**
 * @deprecated Use  Anchor-ds's FieldTextArea instead
 * https://sites.spotify.net/s/%40spotify-internal-anchor-ds/?path=/story/encore-forms-overview--page
 */
const FieldTextArea = forwardRef(
  (
    {
      name,
      maxLength,
      error,
      isShowingError = !!error,
      rows = 12,
      value,
      className,
      containerClassName,
      ...rest
    }: FieldTextAreaProps,
    ref: Ref<HTMLTextAreaElement>
  ) => {
    return (
      <div className={classNames(styles.container, containerClassName)}>
        <textarea
          ref={ref}
          {...rest}
          value={value}
          className={classNames(
            fieldStyles.input,
            styles.textarea,
            {
              [fieldStyles.inputError]: isShowingError,
            },
            className
          )}
          rows={rows}
          name={name}
          id={name}
          data-cy={name}
          maxLength={maxLength}
        />
        <div className={styles.bottomSection}>
          <div
            className={classNames({
              [fieldStyles.errorWrapper]: true,
              [fieldStyles.errorWrapperVisible]: isShowingError,
            })}
          >
            <span className={fieldStyles.errorText}>{error?.message}</span>
          </div>
          {maxLength && (
            <div className={styles.characterCount}>
              {value?.toString().length || 0} / {maxLength}
            </div>
          )}
        </div>
      </div>
    );
  }
);

export { FieldTextArea };
export { ControlledFieldTextArea } from './ControlledFieldTextArea';
